"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _operators = require("rxjs/operators");

var _GlobalMessage = require("../types/GlobalMessage.types");

var _globalMessage = require("./globalMessage.actions");

var errorMessage = /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("b", null, "Internal server error:"), " Try refreshing the page");

var showGlobalErrorEpic = function showGlobalErrorEpic(action$) {
  return action$.pipe((0, _operators.filter)(function (action) {
    return action.payload && action.payload.name === 'AjaxError';
  }), (0, _operators.map)(function (action) {
    return action.payload.status;
  }), (0, _operators.filter)(function (errorCode) {
    return errorCode >= 500;
  }), (0, _operators.mapTo)((0, _globalMessage.showGlobalMessage)({
    text: errorMessage,
    type: _GlobalMessage.MessageType.Error
  })));
};

var permissionErrorEpic = function permissionErrorEpic(action$) {
  return action$.pipe((0, _operators.filter)(function (action) {
    return action.payload && (action.payload.status || action.payload.error_code);
  }), (0, _operators.filter)(function (action) {
    return action.payload.status === 403 || action.payload.error_code === 403;
  }), (0, _operators.mergeMap)(function () {
    return [{
      type: 'PERMISSION_DENIED'
    }];
  }));
};

var globalMessageEpics = [showGlobalErrorEpic, permissionErrorEpic];
var _default = globalMessageEpics;
exports["default"] = _default;